// extracted by mini-css-extract-plugin
export default {"sub_titles":"InfoGroup_sub_titles__Kq3Rl","divider_dot":"InfoGroup_divider_dot__PCV56","bar":"InfoGroup_bar__chD+o"};